import jsc from 'js-cookie';
const converter = {
    /**
     * @param {!string} value
     * @return {string}
     */
    read: function read(value) {
        // return value; // debug (test/index.html -> complex)
        return decodeURIComponent(value);
    },
    /**
     * overrides js-cookie's selective URI encoding.
     * this replace removes "3A|5B|5D|7B|7D" (":", "[", "]", "{" & "}")
     * quick link: http://www.w3schools.com/tags/ref_urlencode.asp
     * @param {!string} value
     * @return {string}
     */
    write: function write(value) {
        value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|2F|3C|3E|3D|3F|40|5E|60|7C)/g, decodeURIComponent);
        return value;
    }
};
export default jsc.withConverter(converter);
//# sourceMappingURL=jsc-converter.js.map